import { useCallback, useState } from 'react'
import { Chart } from '~/components/echarts/chart/chart'
import { ExportButton } from '~/components/echarts/modal/export_button'
import { FullScreenModal } from '~/components/echarts/modal/full_screen_modal'
import { InfoButton } from '~/components/echarts/modal/info_button'
import { MaximizeButton } from '~/components/echarts/modal/maximize_button'
import ModalTooltip from '~/components/echarts/modal_tooltip'

export function Container({
  title,
  chartInfoTitle,
  data,
  isLoading,
  showMaximizeButton = true,
  showExportButton = false,
  onExport,
  hideLabels = false,
  FullScreenModalComponent = FullScreenModal,
}) {
  const [isFullScreen, setIsFullScreen] = useState(false)
  const enableFullScreen = useCallback(() => setIsFullScreen(true), [])
  const disableFullScreen = useCallback(() => setIsFullScreen(false), [])
  const [showInfo, setShowInfo] = useState(false)
  const toggleInfo = useCallback(() => setShowInfo((prev) => !prev), [])

  const supportsModalTooltip = data.type === 'stacked_bar_with_total'
  const [isTooltipOpened, setIsTooltipOpened] = useState(false)
  const [currentSeriesName, setCurrentSeriesName] = useState(null)
  const onChartClick = useCallback(
    (categoryName, _componentType) => {
      if (supportsModalTooltip) {
        setIsTooltipOpened(true)
        setCurrentSeriesName(categoryName)
      }
    },
    [supportsModalTooltip],
  )
  const closeTooltip = useCallback(() => setIsTooltipOpened(false), [])

  return (
    <>
      <Chart
        title={title}
        chartInfoTitle={chartInfoTitle}
        data={data}
        isLoading={isLoading}
        className='mt-4'
        onChartClick={onChartClick}
        hideLabels={hideLabels}
      >
        {showExportButton && <ExportButton onClick={() => onExport('csv')} />}
        {showMaximizeButton && <MaximizeButton onClick={enableFullScreen} />}
      </Chart>

      {isFullScreen && (
        <FullScreenModalComponent show={isFullScreen} onClose={disableFullScreen}>
          <Chart
            title={title}
            chartInfoTitle={chartInfoTitle}
            data={data}
            isLoading={isLoading}
            style={{ height: '75vh' }}
            showInfo={showInfo}
            hideLabels={hideLabels}
          >
            <InfoButton onClick={toggleInfo} />
          </Chart>
        </FullScreenModalComponent>
      )}

      {supportsModalTooltip && (
        <ModalTooltip
          data={data}
          currentSeriesName={currentSeriesName}
          isTooltipOpened={isTooltipOpened}
          closeTooltip={closeTooltip}
        />
      )}
    </>
  )
}
